__turbopack_context__.v({
  "fields": "xbPNzq_fields",
  "footer": "xbPNzq_footer",
  "form": "xbPNzq_form",
  "header": "xbPNzq_header",
  "link": "xbPNzq_link",
  "title": "xbPNzq_title",
});
